import React from 'react';

export default function BeforeCallsRightBottomPanel() {
  return (
    <div
      className="ui segment ignored info attached borderless bg-transparent before-calls-bottom"
      style={{ top: '4px' }}
    >
      <div>
        <i className="ui icon info circle mrrnull pdrxs text-size-xxl mrbxs span-like" />
        <div>
          <div className="color-info mrts">
            <span>{APP.LANGUAGE.WaitingAreaBeforeCallsCallers.InfoPartOne}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
